import { useEffect } from "react";

type Ref = React.RefObject<HTMLElement>;
type ClickHandler = (event: MouseEvent) => void;

const useOnClickOutside = (refs: Array<Ref>, onClickOutside: ClickHandler) => {
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const clickedOutside = !refs.some((ref) =>
                ref?.current?.contains(event.target as Node)
            );
            if (clickedOutside) {
                onClickOutside(event);
            }
        };

        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [refs, onClickOutside]);
};

export default useOnClickOutside;
